module.exports = __webpack_public_path__ + "img/ic-discovercard.9f31cdff.svg";